/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCamelCase = function (val) {
    return val.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
};
exports.toCapitalCase = function (val) {
    return "" + val.substring(0, 1).toUpperCase() + val.substring(1);
};
exports.propertyToMCSSstate = function (base, property) {
    return base + "-is" + exports.toCapitalCase(exports.toCamelCase(property));
};